export const selector = (state) => state.get('featureFlags');
